import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import "./SezioneContenuto.css";

export default function SezioneHome({
  titolo,
  descrizione,
  immagine,
  link,
  invertita = false,
  delay = 0,
}) {
  const ref = useRef(null);
  const [hasBeenVisible, setHasBeenVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasBeenVisible(true);
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: "-25% 0px",
      }
    );

    if (ref.current) observer.observe(ref.current);
    return () => ref.current && observer.unobserve(ref.current);
  }, []);

  return (
    <section
      ref={ref}
      className={`sezione-contenuto ${invertita ? "invertita" : ""}`}
    >
      <motion.div
        className="contenuto"
        initial={{ opacity: 0, y: 50, scale: 0.9 }}
        animate={
          hasBeenVisible
            ? { opacity: 1, y: 0, scale: 1 }
            : { opacity: 0, y: 50, scale: 0.9 }
        }
        transition={{ duration: 0.9, delay, ease: "easeOut" }}
      >
        <h2 className="titolo-mobile">{titolo}</h2>

        <div className="immagine">
          <div className="mockup">
            <img src={immagine} alt="screenshot" />
          </div>
        </div>

        <div className="testo">
          <h2 className="titolo-desktop">{titolo}</h2>
          <p dangerouslySetInnerHTML={{ __html: descrizione }} />
          <a className="bottone" href={link}>
            Scopri di più
          </a>
        </div>
      </motion.div>
    </section>
  );
}


